import {
  SUPPORT_FIRSTNAME_TOKEN,
  applySupportTemplateMessage,
  insertSupportTemplateToken,
} from './support-template-message.util';

/** Same token as support templates — substituted with the creator's first name on hire. */
export const HIRE_MESSAGE_FIRSTNAME_TOKEN = SUPPORT_FIRSTNAME_TOKEN;

export const DEFAULT_HIRE_MESSAGE = `Hi ${HIRE_MESSAGE_FIRSTNAME_TOKEN}, congratulations — you've been hired for this brief. Looking forward to working with you!`;

export function applyHireMessageTemplate(template: string, firstName?: string | null): string {
  return applySupportTemplateMessage(template, firstName);
}

export function insertHireMessageToken(
  body: string,
  token: string,
  selectionStart: number | null,
  selectionEnd: number | null,
): { body: string; cursor: number } {
  return insertSupportTemplateToken(body, token, selectionStart, selectionEnd);
}
